/**
 *@author       罗朝军
 *@date         2021/10/15 16:18
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
import request from "@/config/utils/request";

export function qryOrgTreeUser(data, method = "POST") {
  return request({
    url: "apis/bid/org/qryOrgTreeUser",
    method: method,
    data
  });
}

// 详情页toDoId请求详情
export function qryPurchaseList(data) {
  return request({
    url: "/apis/bid-scp/bidc/qryExpertEvaProjectDetail", // 后端接口
    method: "post",
    data
  });
}

// 标书开启列表
export function queryApi(url, data, method) {
  return request({
    url: url,
    method: method || "post",
    timeout: 30 * 1000,
    data
  });
}

// 查询当前登录外部专家详情
export function getExternalExpertDetail(data) {
  return request({
    url: "/apis/bid-scp/emc/getExternalExpertDetail",
    method: "post",
    data
  });
}

// 验证码验证手机号
export function changeExternalExpertMobile(data) {
  return request({
    url: "/apis/bid-scp/emc/changeExternalExpertMobile",
    method: "post",
    data
  });
}

// 查询当前登录外部专家信息是否已经完善
export function checkIsTakeEffect(data) {
  return request({
    url: "/apis/bid-scp/emc/checkIsTakeEffect",
    method: "post",
    data
  });
}

// 外部专家信息变更保存提交
export function changeExternalExpert(data) {
  return request({
    url: "/apis/bid-scp/emc/changeExternalExpert",
    method: "post",
    data
  });
}

// 外部专家信息变更列表
export function queryChangeList(data) {
  return request({
    url: "/apis/bid-scp/emc/queryChangeList",
    method: "post",
    data
  });
}

// 外部评标专家信息完善
export function updateExternalExpert(data) {
  return request({
    url: "/apis/bid-scp/emc/updateExternalExpert",
    method: "post",
    data
  });
}

// 外部专家获取验证码
export function sendExtExpChangeMobileVerCode(data) {
  return request({
    url: "/apis/bid-scp/emc/sendExtExpChangeMobileVerCode",
    method: "post",
    data
  });
}

// 外部专家退库
export function quitSubmit(data) {
  return request({
    url: "/apis/bid-scp/emc/quitSubmit",
    method: "post",
    data
  });
}

// 外部专家删除
export function deleteExpert(data) {
  return request({
    url: "/apis/bid-scp/emc/deleteExpert",
    method: "post",
    data
  });
}

// 外部专家修改密码
export function changeExternalExpertPassWord(data) {
  return request({
    url: "/apis/bid-scp/emc/changeExternalExpertPassWord",
    method: "post",
    data
  });
}

// 外部专家新增管理单位
export function addExpertManageUnit(data) {
  return request({
    url: "/apis/bid-scp/emc/addExpertManageUnit",
    method: "post",
    data
  });
}

// 选择专业特长
export function selectSubjectNewList(data) {
  return request({
    url: "/apis/bid-scp/bidc/selectSubjectNewList",
    method: "post",
    data
  });
}

export function listDictByCode(data) {
  return request({
    url: "/apis/bid-scp/common/listDictByCode",
    method: "post",
    data
  });
}

export function qryAreaAddressLoginOUtCountry(data) {
  return request({
    url: "/apis/bid-scp/common/qryAreaAddressLoginOUtCountry",
    method: "post",
    data
  });
}

export function qryOrgTreeUsers(data) {
  return request({
    url: "/apis/bid-scp/org/qryOrgTreeUser",
    method: "post",
    data
  });
}

export function listCompSearch(data) {
  return request({
    url: "/apis/bid-scp/common/listCompSearch",
    method: "post",
    data
  });
}

// 专家撤回审批
export function revokeExternalExpert(data) {
  return request({
    url: "/apis/bid-scp/emc/revokeExternalExpert",
    method: "post",
    data
  });
}
